import { Box, LinearProgress, Paper } from "@mui/material"
import MDTypography from "components/MDTypography"
import styles from './drawer.module.css'
import GalleryComponent from 'components/galery/gallery';
import FileInput from 'components/fields/file/fileInput';
import MDBox from "components/MDBox";
import { useState } from "react";
import TabComponent from "./tabs";

export default function RegrasdeOuro({ open, color, txtColor, canUpload }) {
    const [loadUpload, setLoadingUpload] = useState(false)
    const [refetch, setRefetch] = useState(false)
    const [activeKey, setActiveKeyTab] = useState(1);

    const items = [
        {
            label: <MDTypography style={{ fontSize: "15px" }} variant="h6" color="info">
                Evidencias
            </MDTypography>,
            key: '1',
            children: <>
                <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }} >
                    <div style={{ height: "80%", overflowY: "auto", borderRadius: "10px" }} >
                        <GalleryComponent activeKey={activeKey} refetch={refetch} setLoading={setLoadingUpload} />
                    </div>
                    {(!loadUpload && canUpload) && <FileInput refetch={refetch} setRefetch={setRefetch} setLoading={setLoadingUpload} />}
                </div>
            </>
        },
        {
            label: <MDTypography style={{ fontSize: "15px" }} variant="h6" color="info">
                Evidencias de fecho
            </MDTypography>,
            key: '2',
            children: <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }} >
                <div style={{ height: "100%", overflowY: "auto", borderRadius: "10px" }} >
                    <GalleryComponent activeKey={activeKey} refetch={refetch} setLoading={setLoadingUpload} />
                </div>
            </div>
        }
    ]

    return (
        <div>
            <MDBox
                mx={-1.5}
                mt={-1}
                py={1.5}
                px={1.5}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="dark"
                style={{ background: color, margin: "-10px 0 0 -10px" }}
            >
                <MDTypography variant="h6" color={txtColor} >
                    Outros detalhes
                </MDTypography>
            </MDBox>
            <div className={styles.regrasDeOuro}>
                <Paper elevation={3} className={styles.evidencias}  >
                    {
                        loadUpload && <Box sx={{ marginTop: "-5px", overflow: "hidden", width: '100%', backgroundColor: "#fff", paddingBottom: "3px" }}>
                            <LinearProgress />
                        </Box>
                    }

                    <TabComponent items={items} setActiveKey={setActiveKeyTab} />
                </Paper>
            </div>
        </div>
    )
}
